import { authAtom } from "@src/atoms";
import LoadingSpinner from "@src/components/loading-spinner";
import { checkAuth } from "@src/utils/helpers/check-auth";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

function RootRedirect() {
  const [auth, setAuth] = useAtom(authAtom);
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    const validateAuth = async () => {
      if (auth.isAuthenticated === null && !isChecking) {
        setIsChecking(true);
        try {
          const result = await checkAuth();
          setAuth({
            isAuthenticated: result.isAuthenticated,
            user: result.user,
          });
        } catch {
          setAuth({ isAuthenticated: false, user: null });
        } finally {
          setIsChecking(false);
        }
      }
    };
    validateAuth();
  }, [auth.isAuthenticated, isChecking, setAuth]);

  if (auth.isAuthenticated === null || isChecking) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        <LoadingSpinner height={100} width={100} />
      </div>
    );
  }

  if (auth.isAuthenticated) {
    return <Navigate to="/feed" replace />;
  }

  return <Navigate to="/sign-in" replace />;
}

export default RootRedirect;
